import styled from "styled-components";

export const Container = styled.div`

    width: 95%;
    @media(min-width: 1080px){
        width: 65%;
    }
`;